import * as React from "react";
import ReporteesTable from "./ReporteesTable";



export default function DirectReporteesTable({searchTerm,employeeData,shiftStart,shiftEnd}) {
  return <ReporteesTable searchTerm={searchTerm} employeeData={employeeData} shiftStart = {shiftStart}
  shiftEnd ={shiftEnd}/>;
}
